import { ContentCopy, Delete, DynamicFeed } from "@mui/icons-material";
import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

const TYPE_CONFIG = {
  button: { label: "Botões", bg: "#dbeafe", color: "#1d4ed8" },
  list:   { label: "Lista",  bg: "#dcfce7", color: "#166534" },
  number: { label: "Texto",  bg: "#fef3c7", color: "#b45309" },
};

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  const typeMenu = data.typeMenu || "number";
  const typeConf = TYPE_CONFIG[typeMenu] || TYPE_CONFIG.number;
  const options = data.arrayOption || [];

  return (
    <div
      style={{
        backgroundColor: "#fff",
        borderRadius: 14,
        boxShadow: "0 2px 12px rgba(0,0,0,0.12)",
        border: "1px solid #ddd6fe",
        width: 280,
        overflow: "hidden",
        position: "relative",
      }}
    >
      {/* Handle de entrada */}
      <Handle
        type="target"
        position="left"
        style={{
          background: "#8b5cf6",
          width: 14,
          height: 14,
          top: 18,
          left: -9,
          border: "2px solid white",
          cursor: "pointer",
        }}
        isConnectable={isConnectable}
      />

      {/* Header roxo gradiente */}
      <div
        style={{
          background: "linear-gradient(135deg, #7c3aed 0%, #8b5cf6 100%)",
          padding: "8px 10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <DynamicFeed sx={{ width: 16, height: 16, color: "white" }} />
          <span style={{ color: "white", fontSize: 13, fontWeight: 600 }}>
            Menu
          </span>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          {/* Badge de tipo */}
          <span
            style={{
              backgroundColor: typeConf.bg,
              color: typeConf.color,
              fontSize: 9,
              fontWeight: 700,
              padding: "2px 7px",
              borderRadius: 20,
              textTransform: "uppercase",
              letterSpacing: "0.4px",
            }}
          >
            {typeConf.label}
          </span>

          <ContentCopy
            onClick={() => {
              storageItems.setNodesStorage(id);
              storageItems.setAct("duplicate");
            }}
            sx={{
              width: 12,
              height: 12,
              color: "rgba(255,255,255,0.75)",
              cursor: "pointer",
              "&:hover": { color: "white" },
            }}
          />
          <Delete
            onClick={() => {
              storageItems.setNodesStorage(id);
              storageItems.setAct("delete");
            }}
            sx={{
              width: 12,
              height: 12,
              color: "rgba(255,255,255,0.75)",
              cursor: "pointer",
              "&:hover": { color: "white" },
            }}
          />
        </div>
      </div>

      {/* Preview da mensagem */}
      <div
        style={{
          padding: "8px 10px",
          borderBottom: "1px solid #f3f4f6",
          backgroundColor: "#fafafa",
        }}
      >
        <div
          style={{
            fontSize: 11,
            color: "#374151",
            lineHeight: 1.45,
            maxHeight: 48,
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
          }}
        >
          {data.message ? (
            data.message
          ) : (
            <span style={{ color: "#9ca3af", fontStyle: "italic" }}>
              Mensagem do menu...
            </span>
          )}
        </div>
      </div>

      {/* Área de opções */}
      <div style={{ padding: "8px 10px 10px" }}>

        {/* ── typeMenu === "button" ── */}
        {typeMenu === "button" &&
          options.map((option, idx) => (
            <div
              key={option.number}
              style={{
                position: "relative",
                marginBottom: idx < options.length - 1 ? 5 : 0,
              }}
            >
              <div
                style={{
                  border: "1px solid #d1d5db",
                  borderRadius: 8,
                  padding: "6px 32px 6px 10px",
                  fontSize: 11,
                  color: "#1565c0",
                  textAlign: "center",
                  backgroundColor: "white",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  fontWeight: 500,
                }}
              >
                {option.value || `Opção ${option.number}`}
              </div>
              <Handle
                type="source"
                position="right"
                id={"a" + option.number}
                style={{
                  background: "#8b5cf6",
                  width: 14,
                  height: 14,
                  right: -9,
                  top: "50%",
                  transform: "translateY(-50%)",
                  border: "2px solid white",
                  cursor: "pointer",
                }}
                isConnectable={isConnectable}
              />
            </div>
          ))}

        {/* ── typeMenu === "list" ── */}
        {typeMenu === "list" &&
          options.map((option, idx) => (
            <div
              key={option.number}
              style={{
                position: "relative",
                marginBottom: idx < options.length - 1 ? 5 : 0,
                display: "flex",
                alignItems: "center",
                gap: 7,
                padding: "3px 0",
              }}
            >
              <span
                style={{
                  minWidth: 18,
                  height: 18,
                  borderRadius: "50%",
                  backgroundColor: "#8b5cf6",
                  color: "white",
                  fontSize: 9,
                  fontWeight: 700,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                {option.number}
              </span>
              <span
                style={{
                  fontSize: 11,
                  color: "#374151",
                  flexGrow: 1,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {option.value || `Opção ${option.number}`}
              </span>
              <Handle
                type="source"
                position="right"
                id={"a" + option.number}
                style={{
                  background: "#8b5cf6",
                  width: 14,
                  height: 14,
                  right: -9,
                  top: "50%",
                  transform: "translateY(-50%)",
                  border: "2px solid white",
                  cursor: "pointer",
                }}
                isConnectable={isConnectable}
              />
            </div>
          ))}

        {/* Pseudo-botão dropdown visual para "list" */}
        {typeMenu === "list" && options.length > 0 && (
          <div
            style={{
              border: "1.5px solid #8b5cf6",
              borderRadius: 8,
              padding: "5px 10px",
              fontSize: 11,
              color: "#7c3aed",
              textAlign: "center",
              backgroundColor: "#f5f3ff",
              fontWeight: 600,
              marginTop: 7,
            }}
          >
            Selecionar opção ▼
          </div>
        )}

        {/* ── typeMenu === "number" ── */}
        {typeMenu === "number" &&
          options.map((option, idx) => (
            <div
              key={option.number}
              style={{
                position: "relative",
                marginBottom: idx < options.length - 1 ? 4 : 0,
                display: "flex",
                alignItems: "center",
                gap: 6,
                padding: "3px 0",
              }}
            >
              <span
                style={{
                  fontSize: 11,
                  color: "#6b7280",
                  fontWeight: 700,
                  minWidth: 22,
                  flexShrink: 0,
                }}
              >
                [{option.number}]
              </span>
              <span
                style={{
                  fontSize: 11,
                  color: "#374151",
                  flexGrow: 1,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {option.value || `Opção ${option.number}`}
              </span>
              <Handle
                type="source"
                position="right"
                id={"a" + option.number}
                style={{
                  background: "#8b5cf6",
                  width: 14,
                  height: 14,
                  right: -9,
                  top: "50%",
                  transform: "translateY(-50%)",
                  border: "2px solid white",
                  cursor: "pointer",
                }}
                isConnectable={isConnectable}
              />
            </div>
          ))}

      </div>
    </div>
  );
});
